<template>
  <generic-view :prepend="url" :steps="steps" not-numbered :loading="loading">
    <estime v-if="sas" :sasId="sas.id"></estime>
    <introduction v-show="step == 'introduction'" endpoint="inscription-au-registre-etudiants-candidats" @next-step="next"> </introduction>
    <template v-if="sas">
      <div v-for="s in realSteps" :key="s.path">
        <div v-show="step == s.path">
          <headline :code="s.code"></headline>
          <component :is="s.path" :sas="sas" @validation-changed="setState(s.path, $event)" :ref="s.path"> </component>
          <v-btn color="#3a3838" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
        </div>
      </div>
      <soumission v-show="step == 'soumission'" :showAlert="formulaireNonValide" @submit="submit" ref="soumission"></soumission>
    </template>
  </generic-view>
</template>

<script>
import Introduction from "@/components/FormParts/Introduction"
import Identification from "@/components/InscriptionAuRegistreEtudiantsCandidats/Identification"
import Informations from "@/components/InscriptionAuRegistreEtudiantsCandidats/Informations"
import Employeurs from "@/components/InscriptionAuRegistreEtudiantsCandidats/Employeurs"
import Superviseurs from "@/components/InscriptionAuRegistreEtudiantsCandidats/Superviseurs"
import Engagements from "@/components/InscriptionAuRegistreEtudiantsCandidats/Engagements"
import Soumission from "@/components/FormParts/Soumission"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"
import Estime from "@/components/FormParts/Estime"

export default {
  mixins: [FormulaireViewBase, FormulaireBase],

  data() {
    return {
      url: "/inscription-au-registre-etudiants-candidats/",
      paramsName: "inscription-94H",
      loadPanierOnLoad: true,
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "informations", code: "titre-etape-2", state: "" },
        { path: "employeurs", code: "titre-etape-3", state: "" },
        { path: "superviseurs", code: "titre-etape-4", state: "" },
        { path: "engagements", code: "titre-etape-5", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    Introduction,
    Identification,
    Informations,
    Employeurs,
    Engagements,
    Superviseurs,
    Soumission,
    Estime
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  }
}
</script>

<style>
</style>
